export const PAGE_WIDGET = {
    "uid": "widget_SfVs0utv",
    "type": "cleverstory.v2.widgets.page",
    "name": "Page",
    "parent": null,
    "order": 1,
    "systemDefined": false,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
        "desktop": {
            "visible": true,
            "layout": {
                "transform": {
                    "translate": "0px,0px",
                    "rotate": "0deg",
                    "scale": "1,1"
                },
                "width": "1200px",
                "height": "785px"
            },
            "container": {
                "minWidth": 1200,
                "alignment": null
            },
            "alias": null,
            "autoCreateAlias": true,
            "background": null,
            "seo": null,
            "social": null,
            "twitter": null
        },
        "mobile": {
            "visible": false,
            "layout": {
                "transform": null,
                "width": "375px",
                "height": "600px"
            },
            "container": {
                "minWidth": 375,
                "alignment": null
            },
            "alias": null,
            "autoCreateAlias": false,
            "background": null,
            "seo": null,
            "social": null,
            "twitter": null
        }
    },
    "content": null,
    "icon": null
}


export const PALETTE_COMPONENT_WIDGET = {
    "uid": "widget_SfVs0utv",
    "type": "cleverstory.v2.widgets.palette.component",
    "name": "Palette component",
    "parent": null,
    "order": 1,
    "systemDefined": false,
    "fonts": null,
    "actions": null,
    "parameter": null,
    "properties": {
        "desktop": {
            "visible": true,
            "layout": {
                "transform": {
                    "translate": "0px,0px",
                    "rotate": "0deg",
                    "scale": "1,1"
                },
                "width": "1200px",
                "height": "600px"
            },
            "container": {
                "minWidth": 1200,
                "alignment": null
            }
        },
        "mobile": {
            "visible": false,
            "layout": {
                "transform": null,
                "width": "375px",
                "height": "600px"
            },
            "container": {
                "minWidth": 375,
                "alignment": null
            }
        }
    },
    "content": null,
    "icon": null
}